export default __webpack_public_path__ + "static/media/gallery31.625c055c.webp";